import { useState } from 'react'
import defaultAvatar from '@/assets/icons/default-avatar/default-avatar.svg'
import editIcon from '@/assets/icons/edit/edit-icon.svg'
import { message, Skeleton } from 'antd'
import { 
    ProfilePictureContainer,
    ProfilePictureImage,
    ChangeProfileButton
} from './style-component'
import { ProfilePictureProps } from './profile-picture-types'
import { uploadFile } from '@/services/file/file-service'
export const ProfilePicture = ({ 
    initialImage = defaultAvatar,
    onImageChange,
    onClick,
    editable = true
}: ProfilePictureProps) => {
    const [profilePicture, setProfilePicture] = useState(initialImage)
    const [isLoading, setIsLoading] = useState(false)

    const handleProfilePictureChange = async () => {
        if (onClick) {
            onClick();
            return;
        }

        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'
        input.onchange = async (e) => {
            const file = (e.target as HTMLInputElement).files?.[0]
            if (file) {
                try {
                    setIsLoading(true)
                    const { url } = await uploadFile(file)
                    setProfilePicture(url)
                    onImageChange?.(url)
                } catch (error) {
                    console.error('Error uploading image:', error)
                    message.error('Error subiendo la imagen. Por favor, inténtelo de nuevo.')
                } finally {
                    setIsLoading(false)
                }
            }
        }
        input.click()
    }

    return (
        <ProfilePictureContainer>
            {isLoading ? (
                <Skeleton.Avatar active size={120} shape="circle" />
            ) : (
                <ProfilePictureImage 
                    src={profilePicture} 
                    data-testid="profile-picture"
                />
            )}
            {editable && !isLoading && (
                <ChangeProfileButton 
                    data-testid="change-profile-button"
                    onClick={handleProfilePictureChange}
                >
                    <img src={editIcon} alt="edit" />
                </ChangeProfileButton>
            )}
        </ProfilePictureContainer>
    )
}